import React from 'react';
import { useSelector } from 'react-redux';
import { useRequestData, usePrefs, useLabels } from 'wsm-common-data';
import propTypes from 'prop-types';

const LocalCharity = ({ getAttribute, impact, impactBaseUrl, id }) => {
	const { deviceType } = useRequestData();
	const { charitySubmissionUrl, charitySubmissionSource } = usePrefs();
	const labels = useLabels();
	const { dealerCode } = useSelector((state) => state.accountData);

	const LocalCharityImage = ({ bgImagePath, bgImageAlt, name }) => {
		return (
			<div className="col-xs-12 col-sm-7 px-0">
				<img
					className="h-100 img-object-fit-cover"
					src={`${impactBaseUrl}${bgImagePath}`}
					alt={`${
						bgImageAlt !== undefined ? bgImageAlt : name
					} Impact`}
				/>
			</div>
		);
	};

	LocalCharityImage.propTypes = {
		bgImagePath: propTypes.string,
		bgImageAlt: propTypes.string,
		name: propTypes.string
	};

	const LocalCharityContent = ({
		logoPath,
		logoAlt,
		name,
		shortMission,
		impactFact,
		url,
		dealerCharityKey,
		ordinality
	}) => {
		return (
			<div
				className={`col-xs-12 col-sm-5 p-sm-8 py-8 px-6 ${[
					ordinality
				]}`}
			>
				<img
					className={`${
						deviceType === 'MOBILE' ? 'mt-2' : ''
					} mb-sm-5`}
					style={{ maxHeight: '150px' }}
					src={`${impactBaseUrl}${logoPath}`}
					alt={logoAlt}
				/>
				<p className="my-5 text-headline">{name}</p>
				<p className="mb-6 ">{shortMission}</p>
				{impactFact && (
					<div>
						<span className="text-bold">
							{`${labels.get('IMPACT_TO_DATE')} `}
						</span>
						<span>{impactFact}</span>
					</div>
				)}
				<a
					className="d-block mt-6 mb-sm-4 mb-6 text-bold"
					target="_blank"
					rel="noopener noreferrer"
					href={`//${url}`}
				>
					{url}
				</a>
				<a
					className={`btn btn-primary btn-sm local-charity-btn mx-sm-none mb-2 rounded ${
						deviceType === 'DESKTOP' ? 'cta-btn-min-width' : 'w-100'
					}`}
					href={`${charitySubmissionUrl}?source=${charitySubmissionSource}&dealerId=${dealerCode}&charity=${dealerCharityKey}`}
					target="_blank"
					rel="noopener noreferrer"
				>
					{labels.get('WS_CHOOSE_THIS_CHARITY')}
				</a>
			</div>
		);
	};

	LocalCharityContent.propTypes = {
		logoPath: propTypes.string,
		logoAlt: propTypes.string,
		impactFact: propTypes.string,
		name: propTypes.string,
		shortMission: propTypes.string,
		url: propTypes.string,
		dealerCharityKey: propTypes.string,
		ordinality: propTypes.number
	};

	const renderLocalCharities = () => {
		return (
			<div>
				{impact.dealerCharity.map((charity, i) => {
					const {
						img1Path,
						imgAltText,
						impactFact,
						impactImg2Path,
						impactImgAltText,
						name,
						shortMission,
						url,
						dealerCharityKey
					} = charity;
					return (
						<div
							id={dealerCharityKey}
							className={`d-flex justify-content-center ${
								deviceType === 'MOBILE' ? 'flex-column' : ''
							}`}
							key={dealerCharityKey}
						>
							{i % 2 === 1 || deviceType === 'MOBILE' ? (
								<>
									<LocalCharityImage
										bgImagePath={impactImg2Path}
										bgImageAlt={impactImgAltText}
										name={name}
									/>
									<LocalCharityContent
										logoPath={img1Path}
										logoAlt={imgAltText}
										name={name}
										shortMission={shortMission}
										impactFact={impactFact}
										url={url}
										dealerCharityKey={dealerCharityKey}
										ordinality={i % 2}
									/>
								</>
							) : (
								<>
									<LocalCharityContent
										logoPath={img1Path}
										logoAlt={imgAltText}
										name={name}
										shortMission={shortMission}
										impactFact={impactFact}
										url={url}
										dealerCharityKey={dealerCharityKey}
										ordinality={i % 2}
									/>
									<LocalCharityImage
										bgImagePath={impactImg2Path}
										bgImageAlt={impactImgAltText}
										name={name}
									/>
								</>
							)}
						</div>
					);
				})}
			</div>
		);
	};

	return (
		<div id={id}>
			<h1 className="text-headline text-center px-md-15 px-6 mt-8 mb-6">
				{getAttribute.text(48)}
			</h1>
			{renderLocalCharities()}
			<h1 className="text-headline text-center bg-white m-0 px-md-15 px-6 pt-8 pb-6">
				{getAttribute.text(94)}
			</h1>
			<img src={getAttribute.path(95)} alt={getAttribute.text(95)} />
		</div>
	);
};

export default LocalCharity;

LocalCharity.propTypes = {
	id: propTypes.string.isRequired,
	getAttribute: propTypes.shape({
		text: propTypes.func,
		path: propTypes.func
	}).isRequired,
	impact: propTypes.shape({
		dealerCharity: propTypes.arrayOf(
			propTypes.shape({
				length: propTypes.func,
				partsFlag: propTypes.string,
				donationLanguage: propTypes.string
			})
		)
	}).isRequired,
	impactBaseUrl: propTypes.string.isRequired
};
